import Vue from 'vue';
import VueTheMask, { VueMaskDirective } from 'vue-the-mask';

Vue.use(VueTheMask);
Vue.directive('mask', VueMaskDirective);
